<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    class="sidenav background-primary"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
  >
    <mat-toolbar>
      <img
        style="width: 7.5rem;"
        src="/assets/images/logo_slogan_login.svg"
        alt="P for Paquik"
      />
    </mat-toolbar>
    <mat-nav-list>
      <!-- wrap all the nav items in an accordion panel -->
      <mat-accordion displayMode="flat">
        <div *ngFor="let navItem of links">
          <!-- use a simple div for an item that has no children,
            match up the styling to the expansion panel styles -->
          <div class="nav-head" *ngIf="navItem.pages.length === 0; else sub">
            <a
              mat-list-item
              [routerLink]="[navItem.link]"
              routerLinkActive="active"
              class="menu-item"
            >
              <mat-icon>{{ navItem.icon }}</mat-icon>
              {{ navItem.heading }}
            </a>
          </div>

          <!-- use expansion panel for heading item with sub page links -->
          <ng-template #sub>
            <mat-expansion-panel
              class="mat-elevation-z0 custom-expand"
              [expanded]="isActive(navItem)"
              
            >
              <mat-expansion-panel-header
                class="nav-head"
                [expandedHeight]="'48px'"
              >
                <mat-panel-title class="nav-link">
                  <a mat-list-item class="menu-item">
                    <mat-icon>{{ navItem.icon }}</mat-icon>
                    {{ navItem.heading }}
                  </a>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="nav-section">
                <!-- loop through all your sub pages inside the expansion panel content -->
                <div *ngFor="let navPage of navItem?.pages" class="nav-item">
                  <a
                    mat-list-item
                    [routerLink]="[navPage?.link]"
                    routerLinkActive="active"
                    class="menu-item"
                  >
                    <!-- <mat-icon>{{ navPage?.icon }}</mat-icon -->

                    <!-- &nbsp; -->
                    {{ navPage?.title }}
                  </a>
                </div>
              </div>
            </mat-expansion-panel>
          </ng-template>
        </div>
      </mat-accordion>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar style="justify-content: space-between">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
      >
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>{{ getTitleWithoutPaquik() }}</span>
      
      <button mat-stroked-button (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="mx-2 my-1">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>
